import React, { useRef } from 'react';
import { ExtensionCallRoute, selectAllCalls, startCall } from '../../../../redux/slices';
import { useTypedDispatch, useTypedSelector } from '../../../../redux/hooks';
import CallIconButton from '../../../buttons/CallIconButton';
import styles from '../KeypadContacts.module.scss';

const KeypadRouteRow: React.FC<{
    context: 'transfer' | 'new' | 'group' | 'select',
    route: ExtensionCallRoute
}> = ({
    context,
    route
}) => {
        const callsLen = useTypedSelector(selectAllCalls).length;

        const contactRef = useRef<HTMLDivElement>(null);

        const dispatch = useTypedDispatch();

        if (context === 'group') {
            return null;
        }

        return (
            <div
                className={`contact-card ${styles.keypad_contact}`}
                title={route.name}
                ref={contactRef}
                data-in-call={callsLen > 0 || null}
                data-is-select={context === 'select' || null}
            >
                <div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="-3 -3 30 30" fill="none" stroke="var(--font-color-white)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><circle cx="6" cy="19" r="3" /><path d="M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15" /><circle cx="18" cy="5" r="3" /></svg>
                        <p
                            style={{ maxWidth: '120px' }}
                        >
                            {route.name}
                        </p>
                    </div>
                    <div className='contact-card__icons'>
                        <CallIconButton
                            handleCall={() => dispatch(startCall(route.extension.toString(), route.name))}
                        />
                    </div>
                </div>
            </div>
        );
    };

export default KeypadRouteRow;
